import { Badge } from "@twilio-paste/core/badge";
import { Button } from "@twilio-paste/core/button";
import { ArrowDownIcon } from "@twilio-paste/icons/esm/ArrowDownIcon";
import { Box } from "@twilio-paste/core/box";

interface MessageListScrollToBottomProps {
    shouldShow: boolean;
    unreadCount: number;
    onScrollToBottom: () => void;
}

export const MessageListScrollToBottom = ({
    shouldShow,
    unreadCount,
    onScrollToBottom
}: MessageListScrollToBottomProps) => {
    if (!shouldShow) return null;

    return (
        <Box
            element="SCROLL_TO_BOTTOM__CONTAINER"
            position="absolute"
            bottom="space60"
            right="space60"
            zIndex="zIndex10"
        >
            <Button
                element="SCROLL_TO_BOTTOM__BUTTON"
                variant="primary"
                size="circle"
                onClick={onScrollToBottom}
                aria-label="Scroll to bottom"
            >
                <ArrowDownIcon decorative={false} title="Scroll to bottom" />
                {unreadCount > 0 && (
                    <Box position="absolute" top="-15px" right="-15px">
                        <Badge as="span" variant="error">
                            {unreadCount > 99 ? "99+" : unreadCount}
                        </Badge>
                    </Box>
                )}
            </Button>
        </Box>
    );
};
